/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { FreeLookMode_Enum, freeLookMode_EnumFromJSON, freeLookMode_EnumToJSON } from "../../waypoints";

export const protobufPackage = "skills";

/** Timeout duration */
export interface Timeout {
  /** Timeout value in seconds. Range: 1-3600. */
  value: number;
}

/** Arguments for a timed wait action */
export interface TimedWaitActionArgs {
  /** Timeout duration in seconds. */
  timeout:
    | Timeout
    | undefined;
  /** Allow free look to persist during the timed wait action. */
  freeLookMode: FreeLookMode_Enum;
}

export interface TimedWaitResultData {
}

export interface TimedWaitActionStateData {
}

function createBaseTimeout(): Timeout {
  return { value: 0 };
}

export const Timeout = {
  encode(message: Timeout, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.value !== 0) {
      writer.uint32(13).float(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Timeout {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.value = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Timeout {
    return { value: isSet(object.value) ? globalThis.Number(object.value) : 0 };
  },

  toJSON(message: Timeout): unknown {
    const obj: any = {};
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Timeout>, I>>(base?: I): Timeout {
    return Timeout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Timeout>, I>>(object: I): Timeout {
    const message = createBaseTimeout();
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseTimedWaitActionArgs(): TimedWaitActionArgs {
  return { timeout: undefined, freeLookMode: 0 };
}

export const TimedWaitActionArgs = {
  encode(message: TimedWaitActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeout !== undefined) {
      Timeout.encode(message.timeout, writer.uint32(10).fork()).ldelim();
    }
    if (message.freeLookMode !== 0) {
      writer.uint32(16).int32(message.freeLookMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimedWaitActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimedWaitActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeout = Timeout.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.freeLookMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimedWaitActionArgs {
    return {
      timeout: isSet(object.timeout) ? Timeout.fromJSON(object.timeout) : undefined,
      freeLookMode: isSet(object.freeLookMode) ? freeLookMode_EnumFromJSON(object.freeLookMode) : 0,
    };
  },

  toJSON(message: TimedWaitActionArgs): unknown {
    const obj: any = {};
    if (message.timeout !== undefined) {
      obj.timeout = Timeout.toJSON(message.timeout);
    }
    if (message.freeLookMode !== 0) {
      obj.freeLookMode = freeLookMode_EnumToJSON(message.freeLookMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimedWaitActionArgs>, I>>(base?: I): TimedWaitActionArgs {
    return TimedWaitActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimedWaitActionArgs>, I>>(object: I): TimedWaitActionArgs {
    const message = createBaseTimedWaitActionArgs();
    message.timeout = (object.timeout !== undefined && object.timeout !== null)
      ? Timeout.fromPartial(object.timeout)
      : undefined;
    message.freeLookMode = object.freeLookMode ?? 0;
    return message;
  },
};

function createBaseTimedWaitResultData(): TimedWaitResultData {
  return {};
}

export const TimedWaitResultData = {
  encode(_: TimedWaitResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimedWaitResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimedWaitResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TimedWaitResultData {
    return {};
  },

  toJSON(_: TimedWaitResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TimedWaitResultData>, I>>(base?: I): TimedWaitResultData {
    return TimedWaitResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimedWaitResultData>, I>>(_: I): TimedWaitResultData {
    const message = createBaseTimedWaitResultData();
    return message;
  },
};

function createBaseTimedWaitActionStateData(): TimedWaitActionStateData {
  return {};
}

export const TimedWaitActionStateData = {
  encode(_: TimedWaitActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimedWaitActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimedWaitActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TimedWaitActionStateData {
    return {};
  },

  toJSON(_: TimedWaitActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TimedWaitActionStateData>, I>>(base?: I): TimedWaitActionStateData {
    return TimedWaitActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimedWaitActionStateData>, I>>(_: I): TimedWaitActionStateData {
    const message = createBaseTimedWaitActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
